import React, { useState } from "react";
import { useRemoteGitActionsContext } from "../contexts/RemoteGitActionsContext";
import { useTestEndpointsContext } from "../contexts/TestEndpointsContext";
import { useRemoteFileActionsContext } from "../contexts/RemoteFileActionsContext";
import { useIDEContext } from "../contexts/IDEContext";

const ButtonGroup = ({
  selectedRepoName,
  selectedRepoUrl,
  tabs,
  commitMessage,
  setCommitMessage,
  handleDownloadRepoClick,
  handleUpdateFilesClick,
  handleCommitClick,
  handlePushClick,
  handlePullClick,
  handleGetGitChangesClick,
  handleRollbackRepoClick,
}) => {
  const [selectedAction, setSelectedAction] = useState("Select an Action");
  const { fetchGitLogs } = useRemoteGitActionsContext();
  const { fetchGreetings } = useTestEndpointsContext();
  const { fetchFilesFromRepo, buildProject, serveProject, stopServe } =
    useRemoteFileActionsContext();
  const { setFilesList } = useIDEContext();

  const handleActionChange = (e) => {
    setSelectedAction(e.target.value);
    if (e.target.value !== "Commit") {
      setCommitMessage("");
    }
  };

  const handleExecute = async () => {
    switch (selectedAction) {
      case "Build Project":
        if (selectedRepoName) {
          await buildProject(selectedRepoName);
          console.log(`Project ${selectedRepoName} has been built.`);
        }
        break;
      case "Serve Project":
        if (selectedRepoName) {
          await serveProject(selectedRepoName);
          console.log(`Project ${selectedRepoName} is being served.`);
        }
        break;
      case "Stop Serving":
        await stopServe();
        console.log("Stopped serving the project.");
        break;
      case "Download Repo":
        handleDownloadRepoClick();
        break;
      case "Update Files":
        handleUpdateFilesClick();
        break;
      case "Commit":
        handleCommitClick();
        break;
      case "Push":
        handlePushClick();
        break;
      case "Pull Changes":
        handlePullClick();
        break;
      case "Get Git Changes":
        handleGetGitChangesClick();
        break;
      case "Rollback Repository":
        handleRollbackRepoClick();
        break;
      case "Get Git Logs":
        if (selectedRepoName) {
          fetchGitLogs(selectedRepoName);
        }
        break;
      case "Fetch Greetings":
        fetchGreetings();
        break;
      case "Fetch Files from Repo":
        if (selectedRepoName) {
          const files = await fetchFilesFromRepo(selectedRepoName);
          console.log("Fetched files:", files);
          setFilesList(files);
        }
        break;
      default:
        break;
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <select
        value={selectedAction}
        onChange={handleActionChange}
        style={{ margin: "0 5px" }}
      >
        <option disabled>Select an Action</option>
        <option>Build Project</option>
        <option>Serve Project</option>
        <option>Stop Serving</option>
        <option>Download Repo</option>
        <option>Update Files</option>
        <option>Commit</option>
        <option>Push</option>
        <option>Pull Changes</option>
        <option>Get Git Changes</option>
        <option>Rollback Repository</option>
        <option>Get Git Logs</option>
        <option>Fetch Greetings</option>
        <option>Fetch Files from Repo</option>
      </select>
      {selectedAction === "Commit" && (
        <textarea
          placeholder="Commit message"
          value={commitMessage}
          onChange={(e) => setCommitMessage(e.target.value)}
          style={{ margin: "0 5px", width: "200px", height: "60px" }}
        />
      )}
      <button
        onClick={handleExecute}
        style={{ margin: "0 5px" }}
        disabled={
          (selectedAction === "Build Project" && !selectedRepoName) ||
          (selectedAction === "Serve Project" && !selectedRepoName) ||
          (selectedAction === "Update Files" && tabs.length === 0) ||
          (selectedAction === "Commit" && !commitMessage) ||
          (selectedAction !== "Commit" && selectedAction === "Select an Action")
        }
      >
        Execute
      </button>
    </div>
  );
};

export default ButtonGroup;
